module.exports = __webpack_public_path__ + "emaray_banner.94c66fde6a2e76729150.png";


//////////////////
// WEBPACK FOOTER
// C:/dev/emaray.io/src/assets/emaray_banner.png
// module id = ../../../../../src/assets/emaray_banner.png
// module chunks = main